/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as WinningsImport } from './routes/winnings';
import { Route as InfoImport } from './routes/info';
import { Route as GameImport } from './routes/game';
import { Route as R3dImport } from './routes/3d';
import { Route as Import } from './routes/*';
import { Route as IndexImport } from './routes/index';

// Create/Update Routes

const WinningsRoute = WinningsImport.update({
  id: '/winnings',
  path: '/winnings',
  getParentRoute: () => rootRoute,
} as any);

const InfoRoute = InfoImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => rootRoute,
} as any);

const GameRoute = GameImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRoute,
} as any);

const R3dRoute = R3dImport.update({
  id: '/3d',
  path: '/3d',
  getParentRoute: () => rootRoute,
} as any);

const Route = Import.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/*': {
      id: '/*';
      path: '/*';
      fullPath: '/*';
      preLoaderRoute: typeof Import;
      parentRoute: typeof rootRoute;
    };
    '/3d': {
      id: '/3d';
      path: '/3d';
      fullPath: '/3d';
      preLoaderRoute: typeof R3dImport;
      parentRoute: typeof rootRoute;
    };
    '/game': {
      id: '/game';
      path: '/game';
      fullPath: '/game';
      preLoaderRoute: typeof GameImport;
      parentRoute: typeof rootRoute;
    };
    '/info': {
      id: '/info';
      path: '/info';
      fullPath: '/info';
      preLoaderRoute: typeof InfoImport;
      parentRoute: typeof rootRoute;
    };
    '/winnings': {
      id: '/winnings';
      path: '/winnings';
      fullPath: '/winnings';
      preLoaderRoute: typeof WinningsImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/3d': typeof R3dRoute;
  '/game': typeof GameRoute;
  '/info': typeof InfoRoute;
  '/winnings': typeof WinningsRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/3d': typeof R3dRoute;
  '/game': typeof GameRoute;
  '/info': typeof InfoRoute;
  '/winnings': typeof WinningsRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/3d': typeof R3dRoute;
  '/game': typeof GameRoute;
  '/info': typeof InfoRoute;
  '/winnings': typeof WinningsRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: '/' | '/*' | '/3d' | '/game' | '/info' | '/winnings';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/*' | '/3d' | '/game' | '/info' | '/winnings';
  id: '__root__' | '/' | '/*' | '/3d' | '/game' | '/info' | '/winnings';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  Route: typeof Route;
  R3dRoute: typeof R3dRoute;
  GameRoute: typeof GameRoute;
  InfoRoute: typeof InfoRoute;
  WinningsRoute: typeof WinningsRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Route: Route,
  R3dRoute: R3dRoute,
  GameRoute: GameRoute,
  InfoRoute: InfoRoute,
  WinningsRoute: WinningsRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/*",
        "/3d",
        "/game",
        "/info",
        "/winnings"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/*": {
      "filePath": "*.tsx"
    },
    "/3d": {
      "filePath": "3d.tsx"
    },
    "/game": {
      "filePath": "game.tsx"
    },
    "/info": {
      "filePath": "info.tsx"
    },
    "/winnings": {
      "filePath": "winnings.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
